<template>
  <div>
    <el-dialog :visible="visible" title="短信记录" width="1060px" :before-close="handleClose">
      <div class="search-box">
        <el-form ref="formSearch" :inline="true" :model="form" label-width="100px">
           <el-form-item label="买家昵称">
            <el-input size="small" v-model="form.pin" placeholder="请输入买家昵称"></el-input>
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input size="small" v-model="form.mobile" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="发送状态">
             <el-select size="small" v-model="form.status">
              <el-option v-for="(item, index) in sendStatus" :key="index" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="button-group">
            <el-button size="small" class="search" type="primary"  @click="submitForm('formSearch')"> 
                  <i class="el-icon-search" style="display:inline-block;width:14px;height:12px"></i> 查询
              </el-button>
              <el-button size="small" class="reset" type="primary"  @click="resetForm">重置</el-button>
          </div>
        </el-form>
        <div class="table-box">
          <el-table ref="table" v-loading="loading" :data="tableData" tooltip-effect="light" style="width: 100%; border: 1px solid #eee">
            <el-table-column label="买家昵称" prop="pin"></el-table-column>
            <el-table-column label="手机号码" prop="mobile">
              <template slot-scope="scope">
                {{ scope.row.mobile || '--' }}
              </template>
            </el-table-column>
            <el-table-column label="短信内容（展开全部）" prop="content"></el-table-column>
            <el-table-column label="计费条数" prop="smsNumber"></el-table-column>
            <el-table-column label="发送状态" prop="status">
              <template slot-scope="scope">
                <span>
                {{scope.row.status === 0 ? '未发送' :''}}
                {{scope.row.status == '1' ? '已发送' :''}}
                {{scope.row.status == '2' ? '黑名单过滤' :''}}
                {{scope.row.status == '3' ? '过滤重复发送' :''}}
                {{scope.row.status == '4' ? '10分钟内容重复' :''}}
                {{scope.row.status == '5' ? '无效号码' :''}}
                </span>
               </template>
            </el-table-column>
            <el-table-column label="提交时间" prop="subTime"></el-table-column>
            <el-table-column label="发送时间" prop="sendTime"></el-table-column>
          </el-table>
           <!-- 分页器 -->
        <div>
          <el-pagination
              background
              style="text-align: right; margin-top: 20px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.current"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="form.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="crowdTotal"
            ></el-pagination>
        </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getSmsRecord} from "@/api/smsSentRecord"

export default {
  /** 短信记录弹窗 */
  name: 'sms-record',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    batchId: {
      type: null,
      default: ''
    },
    officialFlag: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // visible: true,
      form: {
        batchId: '',
        pin: '',
        mobile: '',
        status: '', 
        batchId: '',
        current: 1,
        size: 10,
      },
      sendStatus: [
        {
          label: '全部',
          value: ''
        },
         {
          label: '已发送',
          value: '1'
        },
         {
          label: '未发送',
          value: '0'
        },
         {
          label: '黑名单过滤',
          value: '2'
        },
        {
          label: '过滤重复发送',
          value: '3'
        },
        {
          label: '10分钟内容重复',
          value: '4'
        },
         {
          label: '无效号码',
          value: '5'
        }
      ],
      loading: false,
      tableData: [],
      params: {
        pageNum: 1,
        pageSize: 10,
      },
      crowdTotal: 0
    }
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    handleClose() {
      this.$emit('onClose')
    },
    getDataList() {
      console.log('this.batch2:', this.batchId)
      this.form.batchId = this.batchId;
      this.form.officialFlag = this.officialFlag;
      this.loading = true;
      getSmsRecord(this.form).then(res => {
        this.loading = false;
        if (res.code == '1') {
          this.tableData = res.data.records
          this.crowdTotal = res.data.total
        }
      })
    },



    submitForm() {
      this.getDataList();
    },
    resetForm() {

    },
    handleSizeChange(val) {
      this.form.size = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.getDataList();
    },
  }
}
</script>

<style lang="scss" scoped>
.search-box{
  .el-input, .el-select{
    width: 136px;
  }
  .button-group{
    display: inline-block;
    margin-left: 20px;
  }
}
</style>
